import {
  debounce,
  requestIdleCallback,
  viewTransition,
} from "@theme/utilities";

const OFFSET = 40;

/**
 * A custom element that manages a floating panel.
 */
export class FloatingPanelComponent extends HTMLElement {
  #updatePosition = async () => {
    // Wait for any view transitions to finish
    if (viewTransition.current) await viewTransition.current;

    const rect = this.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const isMobile = viewportWidth < 990;

    if (isMobile) {
      // On mobile: position panel above summary button
      this.style.top = "unset";
      this.style.bottom = `calc(100% + 5px)`;
      this.style.left = "0";
      this.style.right = "";
      // this.style.width = '90%';
      // this.style.margin = '5px auto';
      // this.style.maxHeight = 'unset';
    } else {
      // On desktop: default behavior
      this.style.top = OFFSET + "px";
      this.style.bottom = "";
      this.style.left = "";

      if (rect.right > viewportWidth) {
        const overflowAmount = rect.right - viewportWidth + OFFSET;
        this.style.left = `-${overflowAmount}px`;
      }

      if (rect.left < 0) {
        const overflowAmount = Math.abs(rect.left) + OFFSET;
        this.style.left = `${overflowAmount}px`;
      }
    }

    this.#mutationObserver.takeRecords();
  };

  #mutationObserver = new MutationObserver(this.#updatePosition);

  #resizeListener = debounce(() => {
    this.#updatePosition();
    const parent = this.closest("details");
    const closeOnResize = this.dataset.closeOnResize === "true";
    if (parent instanceof HTMLDetailsElement && closeOnResize) {
      parent.open = false;
      parent.removeAttribute("open");
      this.#updatePosition();
    }
  }, 100);

  connectedCallback() {
    window.addEventListener("resize", this.#resizeListener);

    requestIdleCallback(() => {
      this.#updatePosition();
      this.#mutationObserver.observe(this, { attributes: true });
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.#resizeListener);
    this.#mutationObserver.disconnect();
  }
}

if (!customElements.get("floating-panel-component")) {
  customElements.define("floating-panel-component", FloatingPanelComponent);
}
